import { ApplicationView, useController } from '@aha-app/mvc';
import classNames from 'classnames';
import React from 'react';
import PresentationController from '../controllers/PresentationController';
import styles from '../styles.module.css';

import {
  ToolExitPresentation,
  ToolNextSlide,
  ToolPreviousSlide,
  ToolPresentationFrames,
} from '../tools/ToolPresent';
import ToolbarHDivider from './ToolbarHDivider';

interface PresentationToolbarProps {
  visible: boolean;
}
const PresentationToolbar: React.FC<PresentationToolbarProps> = ({
  visible,
}) => {
  const presentationController = useController(PresentationController);

  const PreviousSlide = ToolPreviousSlide.buttonComponent();
  const NextSlide = ToolNextSlide.buttonComponent();
  const Sidebar = ToolPresentationFrames.buttonComponent();
  const Exit = ToolExitPresentation.buttonComponent();

  const current = presentationController.currentFrameIndex() + 1;
  const total = presentationController.getFrames().length;

  return (
    <div className={classNames(styles.bottomToolbarContainer)}>
      <div
        className={classNames(styles.presentationToolbar, {
          [styles.presentationToolbarVisible]: visible,
        })}
      >
        <PreviousSlide />
        <div className={classNames(styles.presentationSlideCount)}>
          <strong>{current}</strong>&nbsp;of {total}
        </div>
        <NextSlide />
        <Sidebar />
        <ToolbarHDivider />
        <Exit />
      </div>
    </div>
  );
};

export default ApplicationView(PresentationToolbar);
